var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.753 10.258H6.481v21.271h21.272V10.258z",
    fill: "#FF0032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 11.847v.974h2.152v3.947h1.18V12.82h2.1v-.974H20.68zM12.941 11.847l-1.538 3.23-1.538-3.23H8.174v4.92h1.179v-3.485l1.538 2.973h1.076l1.538-2.973v3.486h1.179v-4.921H12.94zM24.934 28.199a.538.538 0 0 1-.256.46c-.154.103-.308.206-.461.257-.257.052-.513.052-.77.052-.307 0-.563-.052-.82-.103-.204-.051-.41-.205-.563-.41-.154-.205-.205-.461-.205-.82v-.513c0-.359.05-.615.205-.82.154-.205.307-.359.564-.41.256-.103.563-.103.82-.103.256 0 .512 0 .769.052.153.05.358.102.46.256.155.154.206.307.257.461h1.18c0-.359-.155-.717-.41-1.025a2.146 2.146 0 0 0-.924-.564 6.364 6.364 0 0 0-1.384-.154c-.563 0-1.076.103-1.486.257-.41.154-.718.461-.974.82-.205.359-.308.82-.308 1.435v.103c0 .615.103 1.076.308 1.435.205.359.564.666.974.82.41.154.923.257 1.486.257.462 0 .923-.052 1.384-.154.36-.103.667-.308.923-.564.256-.308.41-.667.41-1.025h-1.179z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.956 17.075v7.79h1.589V22.15h3.331c1.794 0 2.666-.922 2.666-2.563 0-1.589-.82-2.511-2.666-2.511h-4.92zM39.9 19.74c0 .666-.358 1.128-1.281 1.128h-3.127v-2.614h3.127c.871 0 1.281.46 1.281 1.127v.359zm4.665-2.665-3.434 7.79h1.486l.871-1.998h4.152l.872 1.999h1.64l-3.434-7.791h-2.153zm.974 1.025 1.589 3.588h-3.127L45.54 18.1zm6.97 3.485v3.23h1.59v-3.23l3.485-4.562h-1.589l-2.614 3.435-2.768-3.435H48.82l3.69 4.562z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMts);
export default __webpack_public_path__ + "static/media/mts.c56b5947680551740e1609a310e008c7.svg";
export { ForwardRef as ReactComponent };